import { defineStore } from "pinia"

const useMain = defineStore('useMain', {
    state: () => {
        return {
            // 默认路由
            defaultMenu: [{
                // home page
                name: "home",
                title: "home",
                icon: '',
                path: '/home',
                component: "layouts/Basic",
                children: [
                    {
                        // home page
                        name: "homepage",
                        title: "Home",
                        icon: 'HomeOutlined',
                        path: '/home/homepage',
                        component: "home/Home",
                    },
                    {
                        // 钢筋翻样
                        name: "rebarMaterials",
                        title: "Rebar Detailing",
                        icon: 'InsertRowAboveOutlined',
                        path: "/home/rebarMaterials",
                        component: 'rebar/RebarMaterials'
                        // component: 'rebar/RevitTeachi'
                    },
                    {
                        // revit钢筋
                        name: "revit",
                        title: "Bim Plugin",
                        icon: 'InsertRowAboveOutlined',
                        path: "/home/revit",
                        component: 'revit/Revit'
                    }
                    // {
                    //     // Tkpm
                    //     name: "tkpm",
                    //     title: "About us",
                    //     icon: 'InsertRowAboveOutlined',
                    //     path: "/home/tkpm",
                    //     component: 'tkpm/Tkpm'
                    // },
                ]
            },
            {
                // 登录页
                name: "login",
                title: "登录",
                icon: '',
                path: '/login/:type',
                component: "login/Login",
                children: []
            },
            ],
            // 管理员路由
            adminMenu: [],
            // 登录成功路由
            loginMenu: [{
                parent: "home",
                name: "user",
                title: "用户中心",
                icon: 'InsertRowAboveOutlined',
                path: "/home/userInfo",
                component: 'user/UserInfo'
            },
            {
                parent: "home",
                name: "pay",
                title: "会员续费",
                icon: 'InsertRowAboveOutlined',
                path: "/home/pay",
                component: 'user/UserPay'
            }],
            rebarMenu: [
                {
                    id: "home",
                    title: "Function introduction",
                    icon: "file-done",
                    url: "",
                    children: [
                        {
                            id: "home",
                            name: "home",
                            title: "Instructional videos",
                            url: ""
                        }
                    ]
                },
                {
                    id: "materials",
                    title: "Bill of Material",
                    icon: "file-done",
                    url: "",
                    children: [
                        {
                            id: "example",
                            name: "example",
                            title: "Reinforcement Detailing",
                            url: "/materials/example"
                        },
                        {
                            id: "diagrams",
                            name: "diagrams",
                            title: "Schematic management",
                            url: '/materials/diagrams',
                        },

                    ]
                },
                {
                    id: "setting",
                    title: "Option settings",
                    icon: "setting",
                    url: "",
                    children: [
                        {
                            id: "specification",
                            name: "specifications",
                            title: "Model specifications",
                            url: "/setting/specification",
                        },
                        {
                            id: "diameter",
                            name: "diameter",
                            title: "Diameter and weight",
                            url: "/setting/diameter",
                        },
                        {
                            id: "connect",
                            name: "connect",
                            title: "Connection",
                            url: "/setting/connect",
                        },
                        {
                            id: "extend",
                            name: "extend",
                            title: "Deduction settings",
                            url: "/setting/extend",
                        },
                    ]
                },
            ],
            windowWidth: document.body.clientWidth,
            windowHeight: document.body.clientHeight,
            userInfo: {}
        }
    },
    /**
     * 用来封装计算属性 有缓存功能  类似于computed
     */
    getters: {
        getMenuItem(state) {
            const menuItem = state.defaultMenu;
            if (Object.keys(state.userInfo).length > 0) {
                let dynamicdeMenu = menuItem[0].children.concat(state.loginMenu);
                console.log(state.userInfo.userRole == 1)
                if (state.userInfo.userRole == 1) {
                    console.log(state.adminMenu)
                    dynamicdeMenu = dynamicdeMenu.concat(state.adminMenu)
                }
                menuItem[0].children = dynamicdeMenu;
            } else {
                let removeItem = [].concat(state.loginMenu, state.adminMenu);
                let menuItemChildren = menuItem[0].children;
                for (let i = 0; i < removeItem.length; i++) {
                    for (let j = 0; j < menuItemChildren.length; j++) {
                        if (removeItem[i].name == menuItemChildren[j].name) {
                            menuItemChildren.splice(j, 1)
                        }
                    }
                }
            }
            console.log("获取当前的所有路由url:", menuItem)
            return menuItem;
        },
        getUserInfo(state) {
            return state.userInfo;
        },
        getRebarMenu(state) {
            let userId = state.userInfo.userId || "15642785459862";
            state.rebarMenu.forEach(parentItem => {
                parentItem.children.forEach(item => {
                    let urlAry = item.url.split("/");
                    urlAry[urlAry.length - 1] = "userId=" + userId;
                    item.url = urlAry.join("/")
                })
            });
            return state.rebarMenu;
        }
    },
    /**
     * 编辑业务逻辑  类似于methods
     */
    actions: {
        setWindowSize(windowSizeParams) {
            this.windowWidth = windowSizeParams[0];
            this.windowHeight = windowSizeParams[1];
        },
        // 设置用户信息
        setUserInfo(userinfo) {
            console.log("设置用户信息", userinfo)
            this.userInfo = userinfo || {};
        },
        setUserAndDynamicRouter(userinfo, router) {
            this.userInfo = userinfo || {};
            this.setDynamicRouter(router)
        },
        // 动态注册路由
        setDynamicRouter(router) {
            console.log("动态添加&&删除路由")
            let dynamicMeun = [].concat(this.loginMenu);
            if (Object.keys(this.userInfo).length > 0) {
                // 注册路由
                console.log(this.userInfo)
                if (this.userInfo.userRole == 1) {
                    dynamicMeun = dynamicMeun.concat(this.adminMenu);
                };
                console.log("添加的路由数据", dynamicMeun);
                dynamicMeun.forEach(item => {
                    let routerConfig = {
                        path: item.path,
                        name: item.name,
                        meta: { title: item.title },
                        component: () => import(`@/views/${item.component}.vue`),
                        children: []
                    }
                    if (item.parent) {
                        router.addRoute(item.parent, routerConfig)
                    } else {
                        router.addRoute(routerConfig)
                    }
                })
            } else {
                dynamicMeun = dynamicMeun.concat(this.adminMenu);
                // 删除路由
                dynamicMeun.forEach(item => {
                    router.removeRoute(item.name)
                })
            }
        },
        // 设置用户过期时间
        setUserExpirationDate(mapData) {
            for (let key in mapData) {
                this.userInfo[key] = mapData[key];
            }
        }
    }
})

export default useMain;